var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerWarningGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5765_10368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13788 2.50016L1.63788 12.0002C1.55026 12.1519 1.50406 12.324 1.50391 12.4993C1.50375 12.6745 1.54965 12.8467 1.637 12.9986C1.72435 13.1505 1.85009 13.2768 2.00162 13.3649C2.15315 13.4529 2.32515 13.4995 2.50038 13.5002H13.5004C13.6756 13.4995 13.8476 13.4529 13.9991 13.3649C14.1507 13.2768 14.2764 13.1505 14.3638 12.9986C14.4511 12.8467 14.497 12.6745 14.4969 12.4993C14.4967 12.324 14.4505 12.1519 14.3629 12.0002L8.86288 2.50016C8.77592 2.3482 8.65036 2.22192 8.4989 2.13409C8.34744 2.04626 8.17547 2 8.00038 2C7.8253 2 7.65333 2.04626 7.50187 2.13409C7.35041 2.22192 7.22485 2.3482 7.13788 2.50016Z",
    fill: "#23C29D",
    stroke: "#23C29D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70313 11.25C8.70313 11.6383 8.38833 11.9531 8 11.9531C7.61167 11.9531 7.29688 11.6383 7.29688 11.25C7.29688 10.8617 7.61167 10.5469 8 10.5469C8.38833 10.5469 8.70313 10.8617 8.70313 11.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.09375
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5765_10368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerWarningGreen);
export default __webpack_public_path__ + "static/media/banner_warning_green.4412ccc80105775893d27f0a540fb4fc.svg";
export { ForwardRef as ReactComponent };